module.exports = __webpack_public_path__ + "static/media/raj-narula.53bf48fd.jpeg";